import { render, staticRenderFns } from "./TrackingDetail.vue?vue&type=template&id=578997b0&"
import script from "./TrackingDetail.vue?vue&type=script&lang=js&"
export * from "./TrackingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrackingDetail.vue?vue&type=style&index=0&id=578997b0&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports